import { Upload } from 'antd';
import cn from 'classnames';
import { displayErrorMessage } from '../../helpers/utils';
import { maxFileNumber, maxFileSize, IMAGE_TYPES } from '../../constants';
import ImageCard from './components/ImageCard/ImageCard';
import UploadButton from './components/UploadButton/UploadButton';
import { DEFAULT_ACCEPT_TYPES } from './constants';
import { getBLOBFileReader } from '../../utils';
import 'antd/lib/upload/style/index';
import 'antd/lib/button/style/index';
import 'antd/lib/progress/style/index';
import 'antd/lib/tooltip/style/index';
import styles from './ImageUpload.module.scss';

const ImageUpload = ({
  accept = DEFAULT_ACCEPT_TYPES,
  imagesList = [],
  uploadStore,
  mainImageIndex,
  removeImageFromDB,
  handlePickMainImage,
}) => {
  const beforeImageUpload = async (file, fileList) => {
    try {
      const fileType = await getBLOBFileReader(file);
      // eslint-disable-next-line
      const imageInList = fileList.reduce((n, img) => n + (img.hasOwnProperty('uid') ? 1 : 0), 0);

      const isCorrectFileFormat = fileType === IMAGE_TYPES.JPEG || fileType === IMAGE_TYPES.PNG;
      const isCorrectNumberOfFiles = imagesList.length + imageInList <= maxFileNumber;
      const isCorrectFileSize = file.size < maxFileSize;

      if (!isCorrectFileFormat) {
        displayErrorMessage('Unsupported file type');
      }

      if (!isCorrectNumberOfFiles) {
        displayErrorMessage('Too many files');
      }

      if (!isCorrectFileSize) {
        displayErrorMessage(`Image must be smaller than ${Math.floor(maxFileSize / 1024 / 1024)}MB!`);
      }

      return isCorrectFileFormat && isCorrectNumberOfFiles && isCorrectFileSize ? false : Upload.LIST_IGNORE;
    } catch (error) {
      displayErrorMessage(error.message);
      return Upload.LIST_IGNORE;
    }
  };

  const deleteImage = (imageUid, imageId) => {
    const updatedImagesList = imagesList.filter(({ uid }) => imageUid !== uid);
    uploadStore(updatedImagesList);

    if (imageId) {
      removeImageFromDB(imageId);
    }
  };

  const imagesListEmptyClassName = imagesList.length === 0 ? styles.bns3_image_list_empty : '';

  return (
    <div id="bns3-image-loader" className={styles.bns3_image_loader_container}>
      <div className={styles.bns3_wrapper}>
        <Upload
          id="bns3-image-uploader"
          action="/"
          listType="picture-card"
          fileList={imagesList}
          beforeUpload={beforeImageUpload}
          multiple
          accept={accept}
          onChange={({ fileList }) => {
            uploadStore([...fileList]);
          }}
          itemRender={(_originNode, file) => (
            <ImageCard
              imagesList={imagesList}
              file={file}
              mainImageIndex={mainImageIndex}
              deleteImage={deleteImage}
              handlePickMainImage={handlePickMainImage}
            />
          )}
          className={cn(styles.bns3_image_uploader, imagesListEmptyClassName)}
        >
          {imagesList.length !== maxFileNumber && <UploadButton imagesAmount={imagesList.length} />}
        </Upload>
      </div>
    </div>
  );
};

export default ImageUpload;
